import React, { useContext } from "react";
import {
  CanvasProvider,
  ProductProvider,
  ModuleProvider,
  ImageProvider,
} from "../provider";
import screen from "../container";
import { AppContext } from "../../../provider/AppProvider";
import imageComp from "../component/ImageTools";

/**
 * @class ProductLayout
 * @description This kind of nesting was necessary in order to use module context.
 * <ProductProvider>, <CanvasProvider> cannot be used in the same level where the mounting by product type
 * logic will be implemented.
 */
function ProductLayout() {
  const { productPreview } = useContext(AppContext);

  return (
    <ProductProvider>
      <ModuleProvider>
        <CanvasProvider>
          <ImageProvider>
            <>
              {productPreview && <screen.ProductPreview />}
              <div className={productPreview ? "d-none" : ""}>
                <screen.ProductScreen />
              </div>
            </>
          </ImageProvider>
        </CanvasProvider>
      </ModuleProvider>
    </ProductProvider>
  );
}

export default ProductLayout;
